export default __webpack_public_path__ + "static/media/aidsMapWite.d6e6d51d.png";